import React, { FunctionComponent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import PrimaryButton from "Shared/Buttons/PrimaryButton";
import styled from "@emotion/styled";

const Root = styled("div")`
    color: #333;
    font-size: 16px;
`;

const Header = styled("div")`
    align-items: center;
    color: #333;
    display: flex;
    flex-direction: column;
    font-size: 16px;
    font-weight: bold;
    justify-content: center;
    padding: 30px 15px 10px;
    text-align: center;
`;

const Content = styled("div")`
    padding: 40px 15px 5px;
    text-align: center;
`;

const Footer = styled("div")`
    padding: 10px 15px 30px;
`;

interface FlyoutGarageEmptyProps {
    isAuthed: boolean;
    onSignIn: () => void;
}

const FlyoutGarageEmpty: FunctionComponent<FlyoutGarageEmptyProps & WithTranslation> = ({ isAuthed, onSignIn, t }) => {
    return (
        <Root>
            <Header>
                <span>{t("FlyoutGarage.FlyoutGarageEmpty.title")}</span>
                <span>{t("FlyoutGarage.FlyoutGarageEmpty.subtitle")}</span>
            </Header>
            <Content>{t("FlyoutGarage.FlyoutGarageEmpty.content")}</Content>
            {!isAuthed && (
                <Footer>
                    <PrimaryButton onClick={onSignIn}>{t("FlyoutGarage.FlyoutGarageEmpty.signIn")}</PrimaryButton>
                </Footer>
            )}
        </Root>
    );
};

export default withTranslation()(FlyoutGarageEmpty);
